import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import Button from '@helsenorge/designsystem-react/components/Button';
import FormGroup from '@helsenorge/designsystem-react/components/FormGroup';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import ChevronLeft from '@helsenorge/designsystem-react/components/Icons/ChevronLeft';
import RadioButton from '@helsenorge/designsystem-react/components/RadioButton';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';
import { useResourcesContext } from './resources';
import { useStateValue } from './useStateValue';
import OffCanvas from '../offcanvas';
const MobileSort = props => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [sortKey, setSortKey, resetSortKey] = useStateValue(props.sortKey);
    const resources = useResourcesContext();
    const handleOpen = () => {
        setIsOpen(true);
    };
    const handleClose = (cb) => {
        setIsOpen(false);
        resetSortKey();
        if (cb) {
            cb(false);
        }
    };
    const handleShowResults = () => {
        props.onSort && sortKey && props.onSort(sortKey);
        handleClose(props.toggleShowFilters);
    };
    const handleSort = event => {
        setSortKey(event.target.value);
    };
    const offCanvasHeader = (_jsxs(_Fragment, { children: [_jsxs(Button, { variant: 'borderless', onClick: () => handleClose(), children: [_jsx(Icon, { svgIcon: ChevronLeft }), resources.mobileBackToFilters] }), _jsx(Spacer, { size: 'xs' }), _jsx(Button, { onClick: handleShowResults, className: "right", children: resources.mobileShowResults })] }));
    return (_jsxs(_Fragment, { children: [_jsx(Button, { "aria-expanded": isOpen, onClick: handleOpen, arrow: "icon", fluid: true, variant: 'outline', children: resources.mobileSortOn }), _jsx(OffCanvas, { header: offCanvasHeader, isOpened: isOpen, onClose: handleClose, children: _jsx(FormGroup, { legend: props.label, name: props.label, children: props.children.map(child => (_jsx(RadioButton, { disabled: props.disabled, defaultChecked: sortKey === child.value, label: child.label || child.value, value: child.value, ref: child.ref, onChange: handleSort }, child.key || child.label || child.value))) }) })] }));
};
export default MobileSort;
